import { createAsyncThunk } from '@reduxjs/toolkit'

import {
  getIssuerConfigRequest,
  // getIssuerRequest,
  getTemporalToken,
} from '../../../../billing-api'
import { users } from '../../invoice-issuance/db/users'
import {
  updateEmisor,
  updateEmailConfig,
} from '../../invoice-issuance/store'

const userName = JSON.parse(localStorage.getItem('userBilligData'))
const userLogin = { companyId: userName?.username }
const user = users.find((user) => user.companyId === userLogin.companyId)
// console.log('user', user)

export const getIssuerInfo = createAsyncThunk(
  'appInvoice/getIssuerInfo',
  async (_, { dispatch }) => {
    const token = await getTemporalToken(user)
    // const response = await getIssuerRequest(token, user.userId)
    const response = await getIssuerConfigRequest(token, user.userId)
    // Cuando el emisor todavia no tiene Parametros de Emisor guardados, el
    // backend responde un error (sin 'user') en vez de los datos - de ahi se
    // sabe si hay que crear (POST) o editar (PUT) al guardar.
    const configExists = Boolean(response?.user)
    const data = response?.user ?? {}

    const emisor = {
      nit: data?.nit ?? '',
      nrc: data?.nrc ?? '',
      nombre: data?.clientName ?? '',
      codActividad: data?.economicActivity?.value ?? '',
      descActividad: data?.economicActivity?.label ?? '',
      nombreComercial: data?.clientName ?? '',
      direccion: {
        departamento: data?.department?.value ?? '',
        municipio: data?.municipality?.value ?? '',
        distrito: data?.district?.value ?? '',
        complemento: data?.address ?? '',
      },
      telefono: data?.phoneNumber ?? '',
      correo: data?.email ?? '',
      codEstable: 'M001',
      codPuntoVenta: 'P001',
      // tipoItemExpor (#34) es exclusivo de FEXE: se agrega en el armado
      // del DTE, no aquí, para no filtrarlo al resto de documentos
    }

    dispatch(updateEmisor(emisor))
    dispatch(
      updateEmailConfig({
        accountType: response?.infoEmailReceptor?.accountType ?? null,
        emailProvider: response?.infoEmailReceptor?.emailProvider ?? null,
        authorized: response?.infoEmailReceptor?.authorized ?? false,
        isActive: response?.isActive ?? false,
      })
    )

    return { data, configExists }
  }
)
